import { Vue, Component, Prop, Watch, Setup } from "@wagich/vue-facing-decorator-metadata";
import { enforce, test } from "vest";
import "vest/enforce/email";

import { CustomFormField } from "../custom-form-field";
import { TextFieldType } from "../models";

import { render } from "./text-field.html";


@Component({
	render
})
export class TextField extends CustomFormField {
	get inputType(): string {
		switch (this.field.type) {
			case "dateTime":
				return "datetime-local";
		}
		return this.field.type ?? "text";
	}

	createValidator(data: any) {
		if (this.field.required) {
			test(this.field.name, "Bitte füllen Sie dieses Feld aus.", () => {
				enforce(data[this.field.name]).isNotEmpty();
			});
		}
		if (this.field.type === TextFieldType.Email) {
			test(this.field.name, "Bitte geben Sie eine gültige E-Mail-Adresse an.", () => {
				enforce(data[this.field.name]).isEmail();
			});
		}
		if (this.field.type === TextFieldType.Number) {
			test(this.field.name, "Bitte geben Sie eine Zahl ein.", () => {
				enforce(data[this.field.name]).isNumeric();
			});
		}
	}
}
